export interface AMSFilamentSettingResponse {
	command: "ams_filament_setting"
	result: "success" | "failed"
	info?: string
	sequence_id: string
}

export function isAMSFilamentSettingResponse(
	response: {
		command: string
		sequence_id: string
	},
	commandSeqId: string
): response is AMSFilamentSettingResponse {
	const result =
		response.command === "ams_filament_setting" && commandSeqId == response.sequence_id
	if (result) {
		console.log('ams_filament_setting:isAMSFilamentSettingResponse', response);
	}
	return result
}
